// ─── Shared Styles ────────────────────────────────────────────────────────────

export const styles = {
    pageWrapper: {
        background: '#f0f4f8',
        margin: "80px 20px 0px 80px",
    },

    // Header
    header: {
        background: 'linear-gradient(135deg, #593E7F 30%, #8b69bb 60%, #593E7F 100%)',
        color: '#fff',
        px: 2,
        py: 2.5,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 3,
        justifyContent: 'space-between',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 2,
    },
    headerIconBox: {
        background: 'rgba(255,255,255,0.15)',
        borderRadius: 2,
        p: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerRight: { display: 'flex', alignItems: 'center', gap: 2 },
    dateBadge: {
        background: 'rgba(255,255,255,0.15)',
        borderRadius: 2,
        px: 1.5,
        py: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },

    // Section Cards
    sectionCard: {
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        background: '#fff',
        px: 2,
        py: 2.5,
        height: '100%',
    },
    sectionTitle: { fontWeight: 700, fontSize: 20, color: '#1a2d45', mb: 0.3 },
    sectionSubtitle: { fontSize: 16, color: '#8a95a3' },

    // Stat Tiles (MS-Hired / Departmental top tiles)
    msHiredTile: {
        borderRadius: 2.5,
        background: 'linear-gradient(135deg, #1a90ff, #0d6efd)',
        color: '#fff',
        p: 2,
        flex: 1,
    },
    departmentalTile: {
        borderRadius: 2.5,
        background: 'linear-gradient(135deg, #a855f7, #7c3aed)',
        color: '#fff',
        p: 2,
        flex: 1,
    },
    tileLabel: { fontSize: 15, fontWeight: 600, letterSpacing: 1, opacity: 0.85, },
    tileCount: { fontSize: 36, fontWeight: 800, lineHeight: 1.1 },
    tileSubtext: { fontSize: 16, opacity: 0.8, },

    // Active badge
    activeBadge: {
        background: '#e8f8f0',
        border: '1px solid #b7e8d0',
        borderRadius: 2,
        px: 1.5,
        py: 0.8,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        my: 1.2
    },

    // Status rows (Today / Yesterday / Monthly)
    statusRowCard: {
        borderRadius: 2,
        border: '1px solid #e8edf2',
        px: 2,
        py: 1.5,
        background: '#fafbfc',
    },
    // statusRowLabel: { fontSize: 12, fontWeight: 700, letterSpacing: 1, color: '#8a95a3', mb: 0 },
    statusRowLabel: { fontSize: 14, fontWeight: 700, letterSpacing: 1, color: '#8a95a3', mb: 1 },
    progressBlue: {
        height: 5, borderRadius: 3, background: '#e0eaff',
        '& .MuiLinearProgress-bar': { background: '#1a90ff' }
    },
    progressPurple: {
        height: 5, borderRadius: 3, background: '#ede9f8',
        '& .MuiLinearProgress-bar': { background: '#a855f7' }
    },

    // Trip detail cards
    tripSectionCard: (color) => ({
        borderRadius: 2.5,
        border: `2px solid ${color === 'blue' ? '#bfd1de' : '#ddd2f3'}`,
        background: color === "blue" ? "#eff7fa" : "#f6f5fd",
        p: 2,
        flex: 1,
    }),
    tripIconBox: (color) => ({
        background: color === 'blue' ? '#eff6ff' : '#f5f3ff',
        borderRadius: 2,
        p: 0.8,
        display: 'flex',
        alignItems: 'center',
        mr: 1.5,
    }),
    tripPeriodLabel: {
        fontSize: 15, fontWeight: 700, letterSpacing: 1, color: '#8a95a3', mb: 0.3
    },
    tripVehicleNum: (color = "blue") => ({
        fontSize: 22, fontWeight: 800,
        color: color === 'blue' ? '#1a90ff' : '#7c3aed',
    }),
    tripTripNum: { fontSize: 22, fontWeight: 800, color: '#1a2d45' },
    tripColLabel: { fontSize: 15, color: '#8a95a3', mb: 0.3 },
    tripRowDivider: { borderBottom: '1px solid #f0f4f8', my: 1 },
    // Charts
    chartCard: {
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        background: '#fff',
        px: 2.5,
        py: 2,
    },
    chartTitle: { fontWeight: 700, fontSize: 22, color: '#1a2d45' },
    deltaRow: { display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5, mb: 1.5 },
    deltaChip: {
        fontSize: 11, color: '#22a35a', fontWeight: 600,
        background: 'transparent', display: 'flex', alignItems: 'center', gap: 0.3,
    },
    legendRow: { display: 'flex', alignItems: 'center', gap: 2 },
    legendItem: (color, dashed) => ({
        display: 'flex', alignItems: 'center', gap: 0.5, fontSize: 11, color: '#5a6a7a',
    }),
    // Performance table
    perfCard: {
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        background: '#fff',
        px: 2.5,
        py: 2,
    },
    perfTabActive: {
        background: '#1a3a7c',
        color: '#fff',
        border: 'none',
        borderRadius: 20,
        px: 2,
        py: 0.6,
        fontSize: 15,
        fontWeight: 600,
        cursor: 'pointer',
    },
    perfTabInactive: {
        background: 'transparent',
        color: '#5a6a7a',
        border: '1px solid #e0e7ef',
        borderRadius: 20,
        px: 2,
        py: 0.6,
        fontSize: 15,
        fontWeight: 500,
        cursor: 'pointer',
    },
    perfHeaderRow: {
        display: 'grid',
        gridTemplateColumns: '40px 1fr  200px 200px 200px 200px',
        px: 1,
        py: 1,
        borderBottom: '1px solid #f0f4f8',
    },
    emPerfHeaderRow: {
        display: 'grid',
        gridTemplateColumns: '40px 1fr 200px 200px 200px 200px 200px 200px 100px',
        px: 1,
        py: 1,
        borderBottom: '1px solid #f0f4f8',
    },
    perfHeaderCell: { fontSize: 15, fontWeight: 700, color: '#aab4c0', letterSpacing: 1 },
    perfRow: (index) => ({
        display: 'grid',
        gridTemplateColumns: '40px 1fr  200px 200px 200px 200px',
        px: 1,
        py: 1.2,
        borderRadius: 2,
        background: index % 2 === 0 ? '#fff' : '#fff8f7',
        borderLeft: index % 2 !== 0 ? '3px solid #f4a89a' : '3px solid transparent',
        alignItems: 'center',
        mb: 0.3,
    }),
    emPerfRow: (index) => ({
        display: 'grid',
        gridTemplateColumns: '40px 1fr 200px 200px 200px 200px 200px 200px 100px',
        px: 1,
        py: 1.2,
        borderRadius: 2,
        background: index % 2 === 0 ? '#fff' : '#fff8f7',
        borderLeft: index % 2 !== 0 ? '3px solid #f4a89a' : '3px solid transparent',
        alignItems: 'center',
        mb: 0.3,
    }),

    perfIndexCell: { fontSize: 15, color: '#aab4c0' },
    perfZoneCell: { fontSize: 15, color: '#1a2d45', fontWeight: 500 },
    perfTripsCell: { fontSize: 15, fontWeight: 700, color: '#1a2d45' },
    perfVehiclesCell: { fontSize: 15, color: '#8a95a3' },
    perfAvgCell: { fontSize: 15, color: '#5a6a7a' },
};